import './reset-password-form.scss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LegalSection, ssgFormsAdapters } from '../../common';
import { LoadingPane } from '@social-solutions/ssg-forms';
import { PropTypes } from 'prop-types';
import { renderLogo } from '../acct.util';
import { withRouter } from 'react-router-dom';
import * as resetPasswordActions from './reset-password.actions';
import queryString from 'query-string';
import React, { Component } from 'react';
import ResetPasswordForm from './reset-password-form';

export class ResetPasswordComponent extends Component {

  componentDidMount() {
    const { resetPasswordActions, location } = this.props;
    const { search } = location || {};
    const query = queryString.parse(search);
    const token = query.tokenId;

    resetPasswordActions.getResetToken(token)
      .catch(() => {});
  }

  render() {
    const { title, resetPassword, tenant } = this.props;

    var tokenState = ssgFormsAdapters.convertLoadingState(resetPassword.token);

    if(!tokenState.isLoading && !tokenState.error) {
      tokenState.data = {};
    }

    if(!!tokenState.error) {
      tokenState.error.errorCode = 'invalid-reset-token';
      tokenState.error.errorMessage = 'This is not a valid link.  Go to the login page to log in or to reset your password.';
    }

    return (
      <div>
        <div id="reset-password">
          <LoadingPane id="reset-password-pane" loadingState={tokenState} loadingMessage={"Verifying Reset Token"}>
            {renderLogo(tenant)}
            <div className="reset-password-form-container">
              <ResetPasswordForm title={title}/>
            </div>
            <div id="legal-wrapper">
              <LegalSection />
            </div>
          </LoadingPane>
        </div>
      </div>

    );
  }
}

ResetPasswordComponent.defaultProps = {
  title: "Reset Your Password",
};

ResetPasswordComponent.propTypes = {
  title: PropTypes.string.isRequired,
};

const mapStateToProps = ({ resetPassword, tenant }) => {
  return {
    resetPassword,
    tenant,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetPasswordActions: bindActionCreators(resetPasswordActions, dispatch)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetPasswordComponent));



// WEBPACK FOOTER //
// src/acct/password/reset-password.component.js